import { render, staticRenderFns } from "./MantenedorGridTodos.vue?vue&type=template&id=073bfad6&"
import script from "./MantenedorGridTodos.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports